export class Shift {
    id: string;
    name: string; 
    code: string;
    description: string;
    shiftType: number;
    organizationLevelId: string;
    organizationLevelName: string;
    startTime: string;
    endTime: string;
    shiftLengthHours: number | null;
    maxWeeklyHours: number;
    averageWeeklyHours: number;
    effectiveStartDate: string;
    effectiveEndDate: string;
    dateCreated: string;
    dateUpdated: string;
}